import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Dosis Harian Parasetamol untuk Anak";
const DESCRIPTION =
  "Gunakan kalkulator ini untuk menghitung dosis harian parasetamol yang tepat berdasarkan berat badan anak dan konsentrasi obat.";
const KEYWORDS = "dosis, kalkulator dosis, obat, berat badan anak, parasetamol";
const OG_URL =
  "https://do-calculate.com/calculator/id/children-paracetamol-dosage-calculator/";
function ParacetamolDosageCalculator() {
  const [weight, setWeight] = useState("");
  const [concentration, setConcentration] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const calculateDosage = () => {
    try {
      if (weight < 44 && concentration) {
        let singleDose;
        const weightNum = parseFloat(weight);
        if (concentration === "160mg/5ml") {
          if (weightNum >= 2.7 && weightNum <= 3.9) singleDose = 1.25;
          else if (weightNum >= 4 && weightNum <= 5.4) singleDose = 1.87;
          else if (weightNum >= 5.5 && weightNum <= 7.9) singleDose = 2.5;
          else if (weightNum >= 8 && weightNum <= 10.9) singleDose = 3.75;
          else if (weightNum >= 11 && weightNum <= 15.9) singleDose = 5;
          else if (weightNum >= 16 && weightNum <= 21.9) singleDose = 7.5;
          else if (weightNum >= 22 && weightNum <= 26.9) singleDose = 10;
          else if (weightNum >= 27 && weightNum <= 31.9) singleDose = 12.5;
          else if (weightNum >= 32 && weightNum <= 43.9) singleDose = 15;
        } else if (concentration === "120mg/5ml") {
          if (weightNum >= 2.7 && weightNum <= 3.9) singleDose = 1.6;
          else if (weightNum >= 4 && weightNum <= 5.4) singleDose = 2.5;
          else if (weightNum >= 5.5 && weightNum <= 7.9) singleDose = 3.3;
          else if (weightNum >= 8 && weightNum <= 10.9) singleDose = 5;
          else if (weightNum >= 11 && weightNum <= 15.9) singleDose = 6.6;
          else if (weightNum >= 16 && weightNum <= 21.9) singleDose = 10;
          else if (weightNum >= 22 && weightNum <= 26.9) singleDose = 13.3;
          else if (weightNum >= 27 && weightNum <= 31.9) singleDose = 16.6;
          else if (weightNum >= 32 && weightNum <= 43.9) singleDose = 20;
        } else if (concentration === "125mg/5ml") {
          if (weightNum >= 2.7 && weightNum <= 3.9) singleDose = 1.6;
          else if (weightNum >= 4 && weightNum <= 5.4) singleDose = 2.4;
          else if (weightNum >= 5.5 && weightNum <= 7.9) singleDose = 3.2;
          else if (weightNum >= 8 && weightNum <= 10.9) singleDose = 4.8;
          else if (weightNum >= 11 && weightNum <= 15.9) singleDose = 6.4;
          else if (weightNum >= 16 && weightNum <= 21.9) singleDose = 9.6;
          else if (weightNum >= 22 && weightNum <= 26.9) singleDose = 12.8;
          else if (weightNum >= 27 && weightNum <= 31.9) singleDose = 16;
          else if (weightNum >= 32 && weightNum <= 43.9) singleDose = 19.2;
        } else if (concentration === "100mg/5ml") {
          if (weightNum >= 2.7 && weightNum <= 3.9) singleDose = 0.4;
          else if (weightNum >= 4 && weightNum <= 5.4) singleDose = 0.6;
          else if (weightNum >= 5.5 && weightNum <= 7.9) singleDose = 0.8;
          else if (weightNum >= 8 && weightNum <= 10.9) singleDose = 1.2;
          else if (weightNum >= 11 && concentration === "100mg/5ml") {
            setError("Harap masukkan berat antara 2.7 dan 10.9 untuk konsentrasi 100 mg/ml");
            return;
          }
        }
        const totalDose = singleDose * 5;
        setResult({
          singleDose,
          totalDose,
        });
      }
      if (weight > 43.9) {
        setError("Harap masukkan berat antara 2.7 dan 43.9");
        return;
      }
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Kalkulator dosis harian parasetamol dirancang khusus untuk orang tua membantu mereka menghitung dosis parasetamol dengan akurat. Tidak perlu perhitungan rumit, cukup masukkan data yang diminta dan dapatkan dosis yang tepat. Aman dan terpercaya, ideal untuk penggunaan di rumah.
                </p>
                <p>
                  Kalkulator dosis parasetamol yang mudah digunakan membantu Anda menentukan dosis obat yang optimal untuk anak Anda berdasarkan berat badan dan konsentrasi obat. Masukkan data yang diminta dan dapatkan dosis secara terperinci. Ideal untuk orang tua dan dokter.
                </p>
                <p>
                  <b>
                    Catatan Penting: Harap diingat bahwa alat ini hanya alat bantu, dan tidak boleh diandalkan sebagai pengganti konsultasi dengan dokter.
                  </b>
                </p>
                <p>
                  Kalkulator ini dikembangkan berdasarkan{" "}
                  <a
                    href="https://www.sfda.gov.sa/id/paracetamol-calculator"
                    rel="nofollow"
                  >
                    Otoritas Umum Makanan dan Obat-obatan Saudi
                  </a>
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div >
                  <div>
                    <hr />
                    <div className="form-group" htmlFor="weight">
                      <label className="form-label ms-2">Masukkan berat badan (kg)</label>
                      <input
                        id="weight"
                        type="number"
                        value={weight}
                        onChange={(e) => setWeight(e.target.value)}
                        placeholder="Masukkan berat badan anak"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label
                        className="form-label ms-2"
                        htmlFor="concentration"
                      >
                        Pilih konsentrasi parasetamol
                      </label>
                      <select
                        id="concentration"
                        value={concentration}
                        onChange={(e) => setConcentration(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        <option value="">Pilih konsentrasi obat</option>
                        <option value="120mg/5ml">120mg/5ml</option>
                        <option value="125mg/5ml">125mg/5ml</option>
                        <option value="160mg/5ml">160mg/5ml</option>
                        <option value="100mg/5ml">
                          100mg/5ml (kurang dari 2 tahun)
                        </option>
                      </select>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={calculateDosage}
                      disabled={!concentration}
                    >
                      Hitung
                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Kesalahan: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Hasil:</h4>
                      <p className="text-white">
                        Dosis tunggal: {result.singleDose} ml
                      </p>
                      <p className="text-white">
                        Dosis harian: {result.totalDose} ml
                      </p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Apa itu dosis harian?</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Definisi Dosis Harian</h2>{" "}
                  </u>
                  <p>
                    Dosis harian adalah jumlah obat yang perlu dikonsumsi anak selama satu hari, dan bervariasi berdasarkan berat badan anak dan konsentrasi obat.
                  </p>
                  <div className="p-3 mb-2 bg-info">
                    Menentukan dosis yang tepat sangat penting untuk memastikan keselamatan anak.
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Bagaimana dosis dihitung?</h2>{" "}
                  </u>
                  <p>
                    Dosis dihitung berdasarkan rumus yang bergantung pada berat badan anak dan konsentrasi obat.
                  </p>
                  <p>
                    Contoh: Jika berat badan anak 5 kg dan konsentrasi obat 160mg/5ml, maka dosis tunggal adalah 1.87 ml.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    Pastikan selalu mengikuti petunjuk dokter atau apoteker.
                  </div>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default ParacetamolDosageCalculator;